import React from 'react';
import { Badge } from 'react-bootstrap';

const AGENT_LABELS = {
  portfolioAgent: { label: 'Portfolio', variant: 'primary' },
  marketDataAgent: { label: 'Market Data', variant: 'success' },
  newsAgent: { label: 'News', variant: 'info' },
  riskAnalysisAgent: { label: 'Risk Analysis', variant: 'warning' },
  directResponse: { label: 'AI', variant: 'secondary' },
};

const AgentBadgeList = ({ agentsUsed = [] }) => {
  if (!agentsUsed.length) return null;

  return (
    <div className="agent-badge-list">
      {agentsUsed.map(agent => {
        const config = AGENT_LABELS[agent] || { label: agent, variant: 'secondary' };
        return (
          <Badge
            key={agent}
            bg={config.variant}
            className="agent-badge"
            title={`Answered using: ${config.label} agent`}
          >
            {config.label}
          </Badge>
        );
      })}
    </div>
  );
};

export default AgentBadgeList;
